import { api } from 'src/boot/axios'
import { COMPANY_STATUSES_PRIORITY } from 'src/constants/companies'
import { STEPS_PRIORITY, TYPES_PRIORITY } from 'src/constants/signup'
import { buildSorting, sortByObjectDate, sortByPriorityObject } from 'src/utils/sort'

let loadCompanyPromise = null

export async function loadCompanies ({ commit, getters }, { companyId, setCompany = false } = {}) {
  try {
    commit('setCompaniesLoading', true)

    if (!loadCompanyPromise) {
      loadCompanyPromise = api.get('companies')
    }
    const { data } = await loadCompanyPromise

    commit('setCompanies', data)

    if (setCompany) {
      companyId ??= getters.getCompany?.id ?? getters.getLastCompanyId
      const currentCompany = data.find(company => company.id === companyId)

      if (currentCompany) {
        commit('setCompany', currentCompany)
      } else {
        const prioritizedCompanies = data.slice()
          .sort(buildSorting(
            sortByPriorityObject('company_status', COMPANY_STATUSES_PRIORITY),
            sortByPriorityObject('wizard_step', STEPS_PRIORITY),
            sortByPriorityObject('type', TYPES_PRIORITY),
            sortByObjectDate('created_at', 'asc')
          ))
        commit('setCompany', prioritizedCompanies[0] ?? null)
      }
    }
  } finally {
    loadCompanyPromise = null
    commit('setCompaniesLoading', false)
    commit('setCompaniesLoaded', true)
  }
}
